import { SVGProps } from 'react';

export const VeryPoor = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 104 104"
        {...props}
    >
        <path
            fill="#DC3E2F"
            d="M52.001 58.5c-10.096 0-18.676 6.327-22.143 15.167h44.287C70.678 64.827 62.098 58.5 52 58.5ZM33.888 52l4.593-4.593L43.075 52l4.593-4.593-4.593-4.594 4.593-4.593-4.593-4.593-4.594 4.593-4.593-4.593-4.593 4.593 4.593 4.593-4.593 4.594L33.888 52Zm18.07-43.333c-23.92 0-43.29 19.37-43.29 43.333 0 23.963 19.37 43.333 43.29 43.333 23.92 0 43.377-19.37 43.377-43.333 0-23.963-19.414-43.333-43.377-43.333Zm.043 78c-19.153 0-34.666-15.514-34.666-34.667 0-19.153 15.513-34.667 34.666-34.667 19.154 0 34.667 15.514 34.667 34.667 0 19.153-15.513 34.667-34.667 34.667Zm18.114-53.04L65.52 38.22l-4.593-4.593-4.593 4.593 4.593 4.593-4.593 4.594L60.928 52l4.593-4.593L70.115 52l4.593-4.593-4.593-4.594 4.593-4.593-4.593-4.593Z"
        />
    </svg>
);
